
import { Service } from './types';

export const NAV_ITEMS = [
  { label: 'Murals', href: '#murals' },
  { label: 'XR / 3D', href: '#xr' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Services', href: '#services' },
  { label: 'Blog', href: '/blog' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export const SERVICES: Service[] = [
  {
    title: 'Murals & Public Art',
    description: 'Transforming physical spaces across Saskatoon and Western Canada with large-scale, high-impact visuals. I specialize in exterior and interior hand-painted murals that tell unique stories, celebrate community heritage, and transform blank walls into local landmarks.',
    tags: ['Exterior Murals', 'Interior Install', 'Vinyl Graphics'],
    icon: 'paint',
    category: 'mural'
  },
  {
    title: 'XR & 3D Visualization',
    description: 'Bridging the gap between the physical and digital worlds. I create WebAR (Web-based Augmented Reality) experiences that require no app download, alongside custom 3D modeling and immersive environment design for educational and commercial applications.',
    tags: ['WebAR', '3D Modeling', 'Unity/Unreal'],
    icon: 'cube',
    category: 'xr'
  },
  {
    title: 'Environmental Graphics',
    description: 'Specializing in navigation-led design and branded environments. I develop comprehensive wayfinding systems, custom signage, and exhibition layouts that improve spatial utility and help people move through physical environments with clarity and purpose.',
    tags: ['Wayfinding', 'Signage', 'Exhibition Design'],
    icon: 'layout',
    category: 'environmental-graphics'
  },
  {
    title: 'Graphic Design & Branding',
    description: 'Crafting durable brand identities and visual systems. From professional logo design to detailed layout work and posters, I focus on building cohesive visual languages that communicate core values and help businesses establish a strong modular presence.',
    tags: ['Identity', 'Posters', 'Social Media', 'Layout'],
    icon: 'layout',
    category: 'design'
  }
];

export const TOOLS = [
  { name: 'Blender', icon: 'https://cdn.simpleicons.org/blender/000000' },
  { name: 'Unity', icon: 'https://cdn.simpleicons.org/unity/000000' },
  { name: 'Adobe Creative Cloud', icon: '/icons/adobe-cc.svg' },
  { name: 'Babylon.js', icon: 'https://cdn.simpleicons.org/babylondotjs/000000' },
];
